'use client'

// src/components/booking/tickets/TicketingIcon.tsx
import { WbkTicketIcon } from "@wbk/svg";
import { jsx, jsxs } from "react/jsx-runtime";
var TicketingIcon = ({ ticket, className = "" }) => {
  return /* @__PURE__ */ jsxs("div", { className: "relative", "data-testid": `ticket-type-badge-${ticket._id}`, children: [
    /* @__PURE__ */ jsx(
      WbkTicketIcon,
      {
        className,
        style: {
          color: ticket.ticket_color
        }
      }
    ),
    /* @__PURE__ */ jsx(
      "span",
      {
        className: "text-body-contrast absolute inset-0 flex items-center justify-center text-xs",
        style: {
          color: ticket.text_color
        },
        children: (ticket == null ? void 0 : ticket.shortcode) || ticket.title.slice(0, 2).toUpperCase()
      }
    )
  ] });
};
var TicketingIcon_default = TicketingIcon;

export {
  TicketingIcon_default
};
//# sourceMappingURL=chunk-KBZMCWX5.mjs.map